import { CollectionFlag, Prefix } from '@/types'
import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface BibliographyMarc {
  prefix: Prefix
  bibliographyId: number
  marcNo: string
  marcType: string
  searchType: SystemCode
  displayTitle: string
  displayAuthor: string
  displayPublished: string
  displayClass: string
  collectionFlag: CollectionFlag
  isbn10: string
  isbn13: string
}

export function BibliographyMarcFromJSON(json: any): BibliographyMarc {
  return {
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Real,
    bibliographyId: exists(json, 'bibliography_id')
      ? json.bibliography_id
      : Prefix.Real,
    marcNo: exists(json, 'marc_no') ? json.marc_no : '',
    marcType: exists(json, 'marc_type') ? json.marc_type : '',
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    displayPublished: exists(json, 'display_published')
      ? json.display_published
      : '',
    displayClass: exists(json, 'display_class') ? json.display_class : '',
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    isbn10: exists(json, 'isbn10') ? json.isbn10 : '',
    isbn13: exists(json, 'isbn13') ? json.isbn13 : ''
  }
}
